<template>
  <div class='h-dialogContainer h-alarm-filter'>
    <form id='addBusyTimeIndicatorThresholdForm'>
      <div class="row h-row-inputBox">
        <div class='col-sm-6'>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('Alarm.nodeSelect')}}:</div>
            <div class='h-borderBox h-filterTopoTree height-464'>
              <TopoTree ref='filterTopoTree' :searchBox='{ show: true }' :checkBox='{ show: true }' :hasBorder='true' graphType="0" @keydown.native.enter='keydown'></TopoTree>
            </div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <button style="border: none;background-color:transparent;margin-left: -32px" type="button" @click="addTimeLabel">
              <span class="icon hero-icon hero-icon-add-small"
                    style="border: none;background-color:transparent;"></span>{{ $t('Alarm.setTheBusyHourTimeRangeTips')}}
          </button>
        </div>
        <div class="col-sm-6 h-col-inputBox" v-for="(item,index) in timeRangeLabelArray" style="display: flex;margin-left: -40px">
          <div>
            <div><span class="h-red-code">* </span>{{$t('Pm.start_time')}}{{index+1}}:</div>
            <div style="width: 100%">
              <ejs-timepicker :id="`dateRangeBeginTime` + index+1" name="dateRangeBeginTime" :format='dateFormat' v-model='item.dateRangeBeginTime'></ejs-timepicker>
            </div>
          </div>
          <div style="width: 10%"></div>
          <div>
            <div><span class="h-red-code">* </span>{{$t('Pm.end_time')}}{{index+1}}:</div>
            <div style="width: 100%">
              <ejs-timepicker :id="`dateRangeEndTime` + index+1" name="dateRangeEndTime" :format='dateFormat' v-model='item.dateRangeEndTime'></ejs-timepicker>
            </div>
          </div>
          <button style="border: none;background-color:transparent;position: relative;top: 12px;" type="button"
                  @click="deleteLinkLabel(index, item.index)">
            <span class="icon hero-icon  hero-icon-remove" style="border: none;background-color:transparent;"></span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import {EventBus} from "@/plugins/eventBus";
import {FormValidator} from "@syncfusion/ej2-vue-inputs";
import TopoTree from '../../topoconfig/TopoTree';

export default {
  name: "addBusyTimeIndicatorThreshold",
  components: {
    TopoTree,
  },
  data() {
    return {
      id: "",
      timeRangeLabelArray:[],
      dateRangeBeginTimeArray: [],
      dateRangeEndTimeArray: [],
      dateFormat: 'HH:mm:ss',
      neIds: [],
      nodeNameArr: [],
      transformNodeNameArr: "",
    }
  },
  mounted() {
  },
  methods: {
    keydown(){
      event.stopPropagation();//禁用回车事件
      event.preventDefault();
    },
    addTimeLabel() {
      if (this.timeRangeLabelArray.length == 5) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.youCanAddAMaximumFfFiveTimeSegments')});
        return false;
      }
      this.timeRangeLabelArray.push({
        dateRangeBeginTime: '',
        dateRangeEndTime: '',
      });
    },
    deleteLinkLabel(index, id) {
      this.$layer.confirm({
        title: `${this.$t('Pm.toastHeader')}`,
        msg: `${this.$t('System.confirmDel')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: `${this.$t('Common.ok')}`,
          func: () => {
            this.timeRangeLabelArray.splice(index, 1);
          }
        }
      })
    },
    getIndicatorThresholdData() {
      //代表校验是否通过
      let flag = false;
      this.getNeIds();
      if (this.neIds.length == 0) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('PDN.pleaseSelectNE')});
        return false;
      }
      if (this.timeRangeLabelArray.length == 0) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.pleaseAddTimePeriod')});
        return false;
      }

      try {
        this.timeRangeLabelArray.forEach(item => {
          if (item.dateRangeBeginTime === '' || item.dateRangeBeginTime === null || item.dateRangeEndTime === '' || item.dateRangeEndTime === null) {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Security.timeNotNull')});
            throw new Error('Security.timeNotNull');
          } else if (Date.parse(item.dateRangeEndTime) <= Date.parse(item.dateRangeBeginTime)) {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Track.endTimeGreaterThanStartTime')});
            throw new Error('Track.endTimeGreaterThanStartTime');
          } else {
            flag = true;
          }
        })
      } catch (e) {
        return false;
      }

      this.dateRangeBeginTimeArray = [];
      this.dateRangeEndTimeArray = [];
        this.timeRangeLabelArray.forEach(item => {
          if (item.dateRangeBeginTime === '' || item.dateRangeBeginTime === null || item.dateRangeEndTime === '' || item.dateRangeEndTime === null) {
            return false;
          }
          if (!this.dateRangeBeginTimeArray.includes(item.dateRangeBeginTime)) {
            this.dateRangeBeginTimeArray.push(item.dateRangeBeginTime)
          }
          if (!this.dateRangeEndTimeArray.includes(item.dateRangeEndTime)) {
            this.dateRangeEndTimeArray.push(item.dateRangeEndTime)
          }
        })

      //判断时间是否重叠
      let timeSegments = [];
      this.timeRangeLabelArray.forEach(item => {
        timeSegments.push({start: item.dateRangeBeginTime, end:item.dateRangeEndTime});
      })
      timeSegments.sort((a, b) => a.start - b.start);

      let hasOverlap = false;
      for (let i = 1; i < timeSegments.length; i++) {
        const currentSegment = timeSegments[i];
        const previousSegment = timeSegments[i - 1];

        if (Date.parse(currentSegment.start) < Date.parse(previousSegment.end)) {
          hasOverlap = true;
          // 根据需求进行处理，可以输出重叠的时间段等
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.TheTimeRangesOverlapResetTheTimeRanges')});
          return false;
        }
      }

      if (flag && !hasOverlap) {
        return {
          id: this.id,
          dateRangeBeginTime: JSON.stringify(this.dateRangeBeginTimeArray),
          dateRangeEndTime: JSON.stringify(this.dateRangeEndTimeArray),
          nodeIdArr: JSON.stringify(this.neIds),
          nodeNameArr: JSON.stringify(this.nodeNameArr),
        }
      } else {
        return false;
      }
    },
    setParams(info) {
      console.log("******setParams-info:", info)

      this.clearData();
      this.id = info.id;
      let dateRangeBeginTimeParse = JSON.parse(info.dateRangeBeginTime);
      let dateRangeEndTimeParse = JSON.parse(info.dateRangeEndTime);
      for (let i = 0; i < dateRangeBeginTimeParse.length; i++) {
        this.timeRangeLabelArray.push({
          dateRangeBeginTime: dateRangeBeginTimeParse[i],
          dateRangeEndTime: dateRangeEndTimeParse[i],
        });
      }
      this.dateRangeBeginTime = new Date(info.dateRangeBeginTime);
      this.dateRangeEndTime = new Date(info.dateRangeEndTime);

      const neIds = JSON.parse(info.nodeIdArr);
      for (let i = 0; i < neIds.length; i++) {
        this.$refs.filterTopoTree.neIdListCache[neIds[i]] = true;
      }
      //刷新拓扑树
      this.$refs.filterTopoTree.refreshCheckStatus();
    },
    getNeIds() {
      const neIdList = [];
      const neNameList = [];

      const nodeList = this.$refs.filterTopoTree.getNodeListWithoutSubnet();

      for (let i = 0; i < nodeList.length; i++) {
        neIdList.push(nodeList[i].id);
        neNameList.push(nodeList[i].name);
      }
      this.neIds = neIdList;
      this.nodeNameArr = neNameList;
    },
    clearData() {
      this.dateRangeBeginTime = "";
      this.dateRangeEndTime = "";
      const errorDom = document.querySelectorAll('label.e-error');
      for (let i = 0; i < errorDom.length; i++) {
        errorDom[i].innerHTML = '';
      }
    },
  },
}
</script>

<style scoped>

</style>
